module.exports = __webpack_public_path__ + "static/media/STREAMER_PLUS.fe908d97.svg";